<h1 mat-dialog-title i18n>Migrate User</h1>

<form [formGroup]="formInputs" (ngSubmit)="onFormSubmit()">
	<div mat-dialog-actions class="row mb-0">
		<div class="col-6 text-center">
			<button
				class="w-100"
				mat-flat-button
				mat-dialog-close
				i18n
			>Cancel</button>
		</div>
		<div class="col-6 text-center">
			<button
				class="w-100"
				type="submit"
				mat-flat-button
				color="primary"
				i18n
				[disabled]="formInputs.invalid"
			>Ok</button>
		</div>
	</div>
</form>
